import Swiper, {Pagination, Scrollbar} from "swiper";

export class Slider {

    constructor() {

        const sliders = document.querySelectorAll('.swiper')


        if (sliders) {
            sliders.forEach(function (e) {
                let el = ".classic-swiper_" + e.getAttribute('data-slug')
                let elPag = ".pagination_" + e.getAttribute('data-slug')
                let elScr = ".scrollbar_" + e.getAttribute('data-slug')


                new Swiper(el, {
                    modules: [Pagination, Scrollbar],
                    pagination: {
                        el: elPag,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">' + (index + 1) + '</span>';
                        },
                        clickable: true
                    },
                    scrollbar: {
                        el: elScr
                    }
                })
            })
        }
    }
}
